/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Seat_Type_Price_Per_MonthInputs */



/**
* | output |
* | --- |
* | "{price} per month" |
*
* @param {Seat_Type_Price_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_type_price_per_month = /** @type {((inputs: Seat_Type_Price_Per_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Type_Price_Per_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.price} pro Monat`)
	return /** @type {LocalizedString} */ (`${i?.price} per month`)
});